/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { ApiPaths } from '@fai/constants/shared-urls';
import type { RegisterInviteDetailResponse } from '@fai/friendli-suite/features/types/auth/model';
import { baseKy } from '@fai/friendli-suite/shared/ky/base-ky';

export async function getInvitationDetail() {
  const response = await baseKy
    .get(ApiPaths.GetInvitationDetail)
    .json<RegisterInviteDetailResponse['data']>();

  return response;
}
